import { jsx as _jsx } from "react/jsx-runtime";
import { IconCheck } from "@tabler/icons-react";
import clsx from "clsx";
import { forwardRef } from "react";
import { useStyles } from "./ui_step_icon.css";
export const UiStepIcon = forwardRef(({ icon, active, completed, error }, ref) => {
    const classes = useStyles();
    return (_jsx("div", { ref: ref, className: clsx(classes.box, active && classes.box_active, completed && classes.box_completed, error && classes.box_error), children: completed ? _jsx(IconCheck, { size: 16 }) : icon }));
});
//# sourceMappingURL=ui_step_icon.js.map